import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import medical_pic from '../assets/photos/medical_equipments/18.jpg';
import promo_pic from '../assets/photos/promotional_materials/12.jpg';
import education_pic from '../assets/photos/educational_solutions/1.jpg';
import moble_pic from '../assets/photos/smart_mobile/2.jpg';
import realestate_pic from '../assets/photos/real_estate/3.jpg';
import telecom_pic from '../assets/photos/telecom_solutions/6.jpg';
import ict_pic from '../assets/photos/ict_solutions/1.jpg';
import agri_pic from '../assets/photos/agricultular_solutions/6.jpg';
import energ_pic from '../assets/photos/energy_solutions/1.jpg';
import green_pic from '../assets/photos/energy_solutions/3.jpg';


import gr1 from '../assets/gr1.jpg';
import gr2 from '../assets/gr2.jpg';
import gr3 from '../assets/gr3.jpg';


import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "uppercase",
											}}
										>
											LEADING THE WAY IN GREEN ENERGY SOLUTION
										</h1>
	
										
	
									</div>
	
									
	
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">
								<img
									src={green_pic}
									style={{
										width: "100%"
									}}
								/>
								<h6
									style={{
										fontSize: "18px",
										marginTop: "20px",
										marginBottom: "20px",
									}}
								>
									In the rapidly evolving energy sector, JIEZHI TECH stands out with its innovative technology and commitment to quality, offering efficient and environmentally friendly energy solutions to customers. Our CNG (Compressed Natural Gas) refueling stations are a prime example of this commitment. Clean Energy for Cleaner Cities As we say, “Clean Energy for Cleaner Cities,” our goal is to make cities more livable through green energy. Choose JIEZHI TECH CO. LTD, choose a cleaner, more efficient, and more…
								</h6>

								<HorizontalImageStrip
									images={[gr1, gr2, gr3]}
								/>
							</div>

							
							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									FAST REFUELING, ZERO COMPROMISE
								</h6>
								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									In today’s fast-paced world, time is of the essence. JIEZHI TECH’s CNG refueling stations are equipped with advanced technology to ensure a quick and efficient refueling process.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									SAFETY, RELIABILITY AND SUSTAINABILITY
								</h6>
								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Safety is always our top priority. JIEZHI TECH’s CNG refueling stations strictly adhere to international safety standards, ensuring that every aspect of the operation is under stringent quality control.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									SMART MANAGEMENT FOR EFFICIENT OPERATIONS
								</h6>
								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									JIEZHI TECH’s CNG refueling stations are not just about hardware; they come with advanced intelligent management systems. Leveraging IoT technology, our stations can monitor equipment status in real-time and provide data analysis and management support.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									CUSTOMIZED SOLUTIONS FOR EVERY NEED
								</h6>
								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We understand that each customer has unique requirements, which is why JIEZHI TECH offers customized CNG refueling station solutions. Whether you need a small-scale refueling station or a large-scale CNG mother station, we can design and…
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6 className="main-section-title">
									THE FUTURE OF FUEL TODAY
								</h6>
								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									JIEZHI TECH is dedicated to driving innovation and development in the energy industry. Our CNG refueling stations are an important part of the future energy solution, and we believe that CNG will be one of the main energy sources for future transportation. Through continuous technological innovation and product development, we continue to lead industry standards and provide higher quality services to our customers. As we say, “CNG, The Future of Fuel Today.” We believe that CNG is the best choice for tomorrow.
								</h6>
							</div>

							
	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}